<template>
    <div class="switch" :class="{'on' : val}" @click="$emit('update:val', !val)">
        <span class="button"></span>
    </div>
</template>

<script>
    export default {
        name: "vSwitch",
        props: ['val'],

    }
</script>

<style scoped lang="less">
    .switch{
        background-color: #cccccc;
        height: 30px;
        width: 60px;
        display: inline-block;
        border-radius: 30px;
        border: 1px solid #BFBFBF;
        position: relative;
        transition: all 200ms ease;

        .button{
            height: 28px;
            width: 28px;
            border-radius: 30px;
            background-color: #ffffff;
            position: absolute;
            left: 0;
            transition: all 200ms ease;
            cursor: pointer;
        }

        &.on{
            background-color: #32c5ff;
            border-color: #32c5ff;

            .button{
                left: 30px;
            }
        }
    }
</style>
